module.exports = __webpack_public_path__ + "img/privilege11.6a357b89.png";